import React, { useState } from 'react';

interface SupportPageProps {
  onBack: () => void;
}

const faqs = [
  { id: 1, question: 'Nasıl Elmas Yüklerim?', answer: 'Profilinizdeki "Cüzdan" veya menüdeki "Elmas Satın Al" bölümünden kredi kartı veya uygulama içi satın alma (IAP) ile elmas yükleyebilirsiniz.' },
  { id: 2, question: 'Nasıl Canlı Yayın Açabilirim?', answer: 'Alt menüde bulunan ortadaki mor (+) veya Canlı Yayına Başla (Go Live) butonuna basarak anında yayın açabilirsiniz.' },
  { id: 3, question: 'Hesabımı Nasıl Gizleyebilir/Silebilirim?', answer: 'Menüden Ayarlar > Gizlilik kısmına girerek hesabınızı dondurabilir veya kalıcı olarak silebilirsiniz.' }
];

const SupportPage: React.FC<SupportPageProps> = ({ onBack }) => {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);

  const toggleFaq = (id: number) => {
    setOpenFaq(openFaq === id ? null : id);
  };

  const handleSendSupport = () => {
    if (!message.trim()) return;
    setSent(true);
    setMessage('');
    setTimeout(() => setSent(false), 3000);
  };

  return (
    <div style={{
      width: '100%', height: '100%',
      background: 'linear-gradient(160deg, #12121c, #0e0e18)',
      display: 'flex', flexDirection: 'column',
      position: 'relative', overflow: 'hidden'
    }}>
      {/* Header */}
      <div style={{
        padding: '50px 20px 20px',
        background: 'rgba(255,255,255,.02)',
        borderBottom: '1px solid var(--border)',
        display: 'flex', alignItems: 'center', gap: 15,
        position: 'relative', zIndex: 10
      }}>
        <button onClick={onBack} className="icon-btn" style={{ background: 'rgba(255,255,255,.05)' }}>
          ←
        </button>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 24 }}>❓</span>
          <h2 className="syne" style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>Yardım & Destek</h2>
        </div>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '0 20px 90px', display: 'flex', flexDirection: 'column', gap: 24 }}>
        
        {/* Banner */}
        <div style={{
          background: 'rgba(255,255,255,.03)', border: '1px solid var(--border)',
          borderRadius: 20, padding: '20px', textAlign: 'center', marginTop: 20
        }}>
          <div style={{ fontSize: 40, marginBottom: 10 }}>🛠️</div>
          <h3 className="syne" style={{ margin: '0 0 8px 0', fontSize: 18, color: '#fff' }}>Size Nasıl Yardımcı Olabiliriz?</h3>
          <p style={{ margin: 0, fontSize: 13, color: 'var(--muted)', lineHeight: 1.5 }}>
            Aşağıdaki sıkça sorulan sorulara göz atabilir veya destek ekibimize direkt mesaj gönderebilirsiniz.
          </p>
        </div>

        {/* FAQ Section */}
        <div>
          <h3 className="syne" style={{ margin: '0 0 16px 0', fontSize: 17, color: '#fff' }}>Sıkça Sorulan Sorular</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {faqs.map(faq => (
              <div key={faq.id} style={{
                background: openFaq === faq.id ? 'rgba(255,255,255,.05)' : 'rgba(255,255,255,.02)',
                border: openFaq === faq.id ? '1px solid rgba(255,255,255,.1)' : '1px solid rgba(255,255,255,.05)',
                borderRadius: 16, overflow: 'hidden', transition: 'all 0.2s'
              }}>
                <button
                  onClick={() => toggleFaq(faq.id)}
                  style={{
                    width: '100%', padding: '16px', background: 'transparent', border: 'none',
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    cursor: 'pointer', textAlign: 'left', color: '#fff'
                  }}
                >
                  <span className="syne" style={{ fontSize: 14, fontWeight: 700, paddingRight: 20 }}>{faq.question}</span>
                  <span style={{ color: 'var(--muted)', transform: openFaq === faq.id ? 'rotate(180deg)' : 'rotate(0deg)', transition: '0.2s' }}>
                    ▼
                  </span>
                </button>
                
                {openFaq === faq.id && (
                  <div style={{ padding: '0 16px 16px', fontSize: 13, color: 'var(--muted)', lineHeight: 1.5 }}>
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Contact Form Section */}
        <div>
          <h3 className="syne" style={{ margin: '0 0 16px 0', fontSize: 17, color: '#fff' }}>Destek Ekibine Yazın</h3>
          <div style={{
            background: 'rgba(255,255,255,.02)', border: '1px solid rgba(255,255,255,.05)',
            borderRadius: 20, padding: '16px'
          }}>
            {sent ? (
              <div style={{ textAlign: 'center', padding: '20px 0', color: 'var(--green)' }}>
                <div style={{ fontSize: 30, marginBottom: 10 }}>✅</div>
                <div style={{ fontWeight: 600 }}>Talebiniz alınmıştır!</div>
                <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 5 }}>En kısa sürede uygulamadan bildirim ile dönüş yapacağız.</div>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Yaşadığınız sorunu veya önerinizi detaylıca yazın..."
                  style={{
                    width: '100%', minHeight: '100px', background: 'rgba(0,0,0,0.3)',
                    border: '1px solid rgba(255,255,255,.1)', borderRadius: 12, padding: '12px',
                    color: '#fff', fontSize: 14, resize: 'vertical', fontFamily: 'inherit'
                  }}
                />
                <button
                  onClick={handleSendSupport}
                  disabled={!message.trim()}
                  style={{
                    padding: '12px', borderRadius: 12, border: 'none',
                    background: message.trim() ? 'linear-gradient(135deg, var(--coral), var(--purple))' : 'rgba(255,255,255,.05)',
                    color: message.trim() ? '#fff' : 'var(--muted)',
                    fontFamily: 'Syne', fontWeight: 700, fontSize: 14,
                    cursor: message.trim() ? 'pointer' : 'not-allowed', transition: 'all 0.2s', minHeight: 44
                  }}
                >
                  Gönder ✉️
                </button>
              </div>
            )}
          </div>
        </div>
        
        {/* Contact Alternatives */}
        <div style={{ display: 'flex', gap: 10 }}>
          <button style={{
            flex: 1, padding: '12px', borderRadius: 14, border: '1px solid rgba(34, 197, 94, 0.3)',
            background: 'rgba(34, 197, 94, 0.05)', color: 'var(--green)',
            fontFamily: 'Syne', fontWeight: 600, fontSize: 13, cursor: 'pointer',
            display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 6
          }} onClick={() => alert('WhatsApp Destek yakında eklenecek.')}>
            💬 WhatsApp
          </button>
          <button style={{
            flex: 1, padding: '12px', borderRadius: 14, border: '1px solid rgba(59, 130, 246, 0.3)',
            background: 'rgba(59, 130, 246, 0.05)', color: 'var(--blue)',
            fontFamily: 'Syne', fontWeight: 600, fontSize: 13, cursor: 'pointer',
            display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 6
          }} onClick={() => alert('Bize Mail Atın: support@buddylive.app')}>
            📧 E-Posta
          </button>
        </div>

      </div>
    </div>
  );
};

export default SupportPage;
